import { render, staticRenderFns } from "./IpPorxy.vue?vue&type=template&id=2e094778&scoped=true"
import script from "./IpPorxy.vue?vue&type=script&lang=js"
export * from "./IpPorxy.vue?vue&type=script&lang=js"
import style0 from "./IpPorxy.vue?vue&type=style&index=0&id=2e094778&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e094778",
  null
  
)

export default component.exports